import { ResultVM } from "../models/Core/result-vm";
import store from "../store";
import { logout, refreshToken } from "../store/auth";
import * as app from "./AppService";

var baseUrl = "";

var IsUpdatingToken = false;
export var LoadingTime = 0;
function hideLoading(withOutSpinner: boolean) {
    if (!withOutSpinner && LoadingTime-- === 1) app.HideLoading();
}
export function BaseUrl() {
    return baseUrl;
}

export function get(url: string, headerObject: any, OkCb: (data: ResultVM) => void, withOutSpinner: boolean = false, IsAfterUpdateToken: boolean = false) {
    if (!headerObject) headerObject = {};
    const token = store.getState().loginState.token;
    const parameters = Object.keys(headerObject)
        .map((key) => (key + "=" + (
            Array.isArray(headerObject[key]) ? headerObject[key].toString() :
                typeof headerObject[key] === "object" ? JSON.stringify(headerObject[key]) :
                    headerObject[key]))).join("&");
    let Params = "";
    if (parameters && parameters.length > 0)
        Params += "?" + parameters;

    if (!withOutSpinner) {
        LoadingTime++;
        app.ShowLoading();
    }
    const controller = new AbortController();
    let headers: Record<string, string> = {
        "Content-Type": "application/json; charset=UTF-8",
    };
    if (token)
        headers["Authorization"] = "Bearer " + token;

    fetch(baseUrl + url + Params, {
        signal: controller.signal,
        method: "get",
        credentials: "include",
        headers,
    }).then((response) => {
        if (response.ok) return response.json();
        throw new Error(
            response.status + " : " + response.statusText + "( " + url + " )"
        );
    }).then((data) => {
        if (OkCb && typeof OkCb == "function") OkCb(data);
    }).catch((errorMsg) => {
        if (
            errorMsg.message.length > 3 &&
            errorMsg.message.substring(0, 3) === "401" &&
            !IsAfterUpdateToken
        )
            updateToken(url, headerObject, OkCb, "get", withOutSpinner);
        else app.showAlert(errorMsg.message);
    }).finally(() => {
        hideLoading(withOutSpinner);
    });
}

interface CompressionStream { 
    readable: ReadableStream<Uint8Array>;
    writable: WritableStream<Uint8Array>;
}
declare const CompressionStream: {
    new(format: string): CompressionStream;
};
async function compressBody(body: any): Promise<{
    compressedBody: Uint8Array | string;
    encoding: string | null;
}> {
    const json = JSON.stringify(body);
    const byteLength = new TextEncoder().encode(json).length;

    // 🔸 إذا حجمها أقل من 100 كيلوبايت، لا نضغطها
    if (byteLength < 100_000) {
        return { compressedBody: json, encoding: null };
    }

    // 🔸 إذا كان المتصفح يدعم CompressionStream (Brotli أولاً)
    if (typeof CompressionStream !== "undefined") {
        try {
            const cs = new CompressionStream("br");
            const writer = cs.writable.getWriter();
            writer.write(new TextEncoder().encode(json));
            writer.close();

            const compressed = await new Response(cs.readable).arrayBuffer();
            return { compressedBody: new Uint8Array(compressed), encoding: "br" };
        } catch {
            console.warn("Brotli compression failed, sending uncompressed.");
        }
    }

    // 🔸 Fallback: بدون ضغط
    return { compressedBody: json, encoding: null };
}

export async function post(url: string, body: any, OkCb: (data: ResultVM) => void, IsAfterUpdateToken: boolean = false, withOutSpinner: boolean = false) {
    const token = store.getState().loginState.token;
    if (!withOutSpinner) {
        LoadingTime += 1;
        app.ShowLoading();
    }
    const controller = new AbortController();


    const { compressedBody, encoding } = await compressBody(body);
    let headers: Record<string, string> = {
        "Content-Type": "application/json; charset=UTF-8",
    };
    if (token)
        headers["Authorization"] = "Bearer " + token;
    if (encoding) 
        headers["Content-Encoding"] = encoding;

    fetch(baseUrl + url, {
        signal: controller.signal,
        method: "post",
        credentials: "include",
        headers ,
        body: compressedBody,
    }).then((response) => {
        if (response.ok) return response.json();
        throw new Error(
            response.status + " : " + response.statusText + "( " + url + " )"
        );
    }).then((data: any) => {
        if (OkCb) OkCb(data);
    }).catch((errorMsg) => {
        if (
            errorMsg.message.length > 3 &&
            errorMsg.message.substring(0, 3) === "401" &&
            !IsAfterUpdateToken &&
            url !== "/Login/RefreshToken"
        )
            updateToken(url, body, OkCb, "post", withOutSpinner);
        else if (url === "/Login/RefreshToken") {
            store.dispatch(logout);
            window.open("/Signin", "_self");
        }
        else
            app.showAlert(errorMsg.message);
    }).finally(() => {
        hideLoading(withOutSpinner);
    });
}

export function updateToken(url: string, body: any, OkCb: (data: ResultVM) => void, type: string, withOutSpinner: boolean) {
    if (IsUpdatingToken) {
        setTimeout(() => {
            if (type === "get") get(url, body, OkCb, withOutSpinner, false);
            else post(url, body, OkCb, false, withOutSpinner);
        }, 1000);
        return;
    }
    IsUpdatingToken = true;

    post(
        "/Login/RefreshToken",
        "",
        (res) => {
            IsUpdatingToken = false;
            if (res.Success) {
                store.dispatch(refreshToken(res.AdditionalData));
                if (type === "get") get(url, body, OkCb, withOutSpinner, true);
                else post(url, body, OkCb, true, withOutSpinner);
            } else {
                store.dispatch(logout);
                window.open("/Signin", "_self");
            }
        },
        true,
        true
    );
}